import ExpertStatusIcon from "./ExpertStatusIcon";

(function () {
  const styles = ".expert-status-icon {\n  display: inline-flex;\n  margin: 0 10px 0 0;\n}\n.expert-status-icon__vertical-align {\n  vertical-align: middle;\n}\n.expert-status-icon__expert-search {\n  margin: -2px -10px 0 0;\n}\n.expert-status-icon__epl-view {\n  margin: 0 0 0 5px;\n  vertical-align: inherit;\n}";
  const fileName = "index_ExpertStatusIcon";
  const element = document.querySelector("style[data-sass-component='index_ExpertStatusIcon']");

  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

export default ExpertStatusIcon;